import Vue from 'vue'
import Compontent from './func-payPanel'

const PayPanel = Vue.extend(Compontent)

const pay = (options) => {
  const instance = new PayPanel({
    propsData: options
  })
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  // document.body.addClass('popup-parent--hidden')
  document.body.style.overflow = 'hidden'
  document.body.style.paddingRight = '17px'

  instance.$on('closed', () => {
    document.body.removeChild(instance.vm.$el)
    document.body.removeAttribute('style')
    // document.body.removeClass('popup-parent--hidden')
    instance.vm.$destroy()
  })
  return instance.vm
}

export default pay



// WEBPACK FOOTER //
// ./src/components/commonPayPanel/function.js